
import '~/assets/scss/index.scss'

import LnbCmp from '~/components/common/LnbCmp.vue' // LNB 아코디언
import MyHeader from '@/pages/mb/mbc/SCR_MBC_0110.vue' // 마이페이지 헤더 (회원정보)
import Csh0001 from '@/pages/cs/csh/SCR_CSH_0001.vue'
import Csh0002 from '@/pages/cs/csh/SCR_CSH_0002.vue'
import Csh0003 from '@/pages/cs/csh/SCR_CSH_0003.vue'
import Csh0004 from '@/pages/cs/csh/SCR_CSH_0004.vue'
import { commonfunc } from '~/mixin/common'
import { csMixin } from '~/mixin/cs/csMixin'
import { homepageTag } from '~/utils/criteo'

export default {
  name: 'SCH0000',
  components: {
    LnbCmp,
    MyHeader,
    Csh0001,
    Csh0002,
    Csh0003,
    Csh0004
  },
  mixins: [commonfunc, csMixin],
  layout: 'DsMainLayout',
  data () {
    return {
      breadcrumbs: [
        {
          url: process.env.WEB_BASE_URL + '/cs/csh/SCR_CSH_0000',
          text: '고객센터',
        },
      ],
      searchInput: '',
      currentComponent: 'Csh0001',
      orderList: {},
      csh0003Form: {},
      csh0004Form: {}
    }
  },
  jsonld () {
    const items = this.breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.url,
        name: item.text,
      },
    }))
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items,
    }
  },
  computed: {},
  beforeMount () {
    // if (this.isExist(this.$route.query.pgNm)) {
    //   this.currentComponent = this.$route.query.pgNm
    // } else {
    //   this.currentComponent = 'Csh0001'
    // }
  },
  mounted () {
    homepageTag('')
  },
  methods: {
    prcsCsh0001 (prodItem) {
      console.log(prodItem)
      this.orderList = JSON.parse(prodItem)
      this.currentComponent = 'Csh0002'
    },
    prcsCsh0002 (form) {
      console.log(form)
      this.csh0003Form = JSON.parse(form)
      this.currentComponent = 'Csh0003'
    },
    prcsCsh0003 (form) {
      console.log(form)
      this.csh0004Form = JSON.parse(form)
      window.scrollTo({ top: 0, left: 0 }) // 스크롤 초기화
      this.currentComponent = 'Csh0004'
    },
    backCmpHandler (cmpNm) {
      console.log(cmpNm)

      this.currentComponent = cmpNm
    }
  }
}
